import {
  ToggleButton,
  ToggleButtonGroup,
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography,
  FormControl,
  Stack,
} from '@mui/material';

import { Business as CompanyIcon, Person as IndividualIcon } from '@mui/icons-material';

import { OrganizationType } from '@localstack/types';

import { Controller, useFormContext, useWatch } from 'react-hook-form';

import { getTaxIdExample, VALIDATION_RULES } from '@localstack/services';

import { TaxIdTextField } from '../../../account/TaxIdTextField';

import { ControlledTextField } from '../../../../form';

export const TaxElement = ({ requiresPayment }: { requiresPayment: boolean }): JSX.Element => {
  const { control } = useFormContext();
  const orgType = useWatch({ control, name: 'orgType' });
  const country = useWatch({ control, name: 'country' });
  const taxId = useWatch({ control, name: 'tax_id' });

  return (
    <Card>
      <CardHeader title="Order Information" />
      <CardContent>
        <Typography paragraph>Are you purchasing as an individual or on behalf of a company?</Typography>
        <FormControl fullWidth>
          <Controller
            name="orgType"
            control={control}
            rules={{ required: 'Please select an organization type' }}
            render={({ field }) => (
              <ToggleButtonGroup
                {...field}
                exclusive
                onChange={(_event, newValue) => {
                  if (newValue !== null) {
                    field.onChange(newValue);
                  }
                }}
                aria-label="organization type"
                fullWidth
              >
                <ToggleButton value={OrganizationType.INDIVIDUAL} aria-label="Individual" color="primary">
                  <Box display="flex" alignItems="center">
                    <IndividualIcon />
                    <Box mr={1} />
                    <span>Individual</span>
                  </Box>
                </ToggleButton>
                <ToggleButton value={OrganizationType.COMPANY} aria-label="Company" color="primary">
                  <Box display="flex" alignItems="center">
                    <CompanyIcon />
                    <Box mr={1} />
                    <span>Company</span>
                  </Box>
                </ToggleButton>
              </ToggleButtonGroup>
            )}
          />
        </FormControl>
        {orgType === OrganizationType.COMPANY && (
          <Stack spacing={2} marginTop={2}>
            <ControlledTextField
              required
              name="name"
              label="Company Name"
              placeholder="Company Name"
              fullWidth
              variant="outlined"
              rules={VALIDATION_RULES.safeStringRequired}
            />
            <TaxIdTextField
              name="tax_id"
              label="TAX ID"
              placeholder={getTaxIdExample(country) || ''} // TODO: this is not working for all countries
              fullWidth
              variant="outlined"
              taxId={taxId}
              required={requiresPayment}
              rules={{
                ...VALIDATION_RULES.safeStringOptional,
                ...VALIDATION_RULES.taxId(country),
              }}
              country={country}
            />
          </Stack>
        )}
      </CardContent>
    </Card>
  );
};
